import { LegalLayout } from "@/pages/LegalLayout";
import { termos, termsEn } from "@/content/legal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Termos() {
  const { lang } = useLanguage();
  return <LegalLayout doc={lang === "pt" ? termos : termsEn} testId="terms-of-use-page" />;
}
